import Swiper, { Autoplay, Pagination, EffectFade } from 'swiper';
Swiper.use([Autoplay, Pagination, EffectFade]);
// import Swiper from 'swiper/bundle';

const setHeroSlider = () => {
  const slideLength = document.querySelectorAll(
    ".js-hero-slider .swiper-slide"
  ).length;

  if (slideLength > 1) {
    const sliders = document.querySelectorAll(".js-hero-slider");
    sliders.forEach((element, index) => {
      var swiper = new Swiper(element, {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 1500,
        loop: true,
        effect:'fade',
        fadeEffect: {
          crossFade: true
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChange: function () {
            if (this.realIndex > 0) {
              this.params.autoplay.delay = 3500
            }
          },
        },
      });
    });
  } else {
    // $(".js-hero-slider").addClass("slideNone");
  }
}

export default setHeroSlider;